import { Routes, Route, Outlet, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import Login from './pages/Login';
import ListaProdotti from './pages/ListaProdotti.js';
import MappaTavoli from './pages/MappaTavoli.js';
import ProtectedRoute from './components/ProtectedRoute.js';
import Prenotazioni from './pages/Prenotazioni.js';
import ListaPrenotazioni from './pages/ListaPrenotazioni.js';
import ListaOrdini from './pages/ListaOrdini.js';
import ClientiPage from './pages/Clienti.js';
import Statistiche from './pages/Statistiche.js';
import Utenti from './pages/Utenti.js';
import ConfigurazioneMenu from './pages/Menu.js';
import GestioneCategorie from './pages/GestioneCategorie.js';
import GestioneVarianti from './pages/GestioneVarianti.js';
import LandingPage from './pages/LandingPage.js';
import SelezioneComande from './pages/SelezionaComande.js';
import AdminPage from './pages/AdminPage.js';
import PuntoCassa from './pages/PuntoCassa.js';
import StampaPrenotazioni from './pages/StampaPrenotazioni.js';
import Comunicazioni from './pages/Comunicazioni.js';
import FatturazionePage from './pages/FatturazionePage.js';
import GestioneAllestimentiPage from './pages/GestioneAllestimentiPage.js';
import GestioneSetupsPage from './pages/GestioneSetupsPage.js';
import GestioneUsageTypesPage from './pages/GestioneUsageTypesPage.js';
import GestioneRepartiPage from './pages/GestioneRepartiPage.js';
import Preventivi from './pages/Preventivi.js';
import PlanningPrenotazioni from './pages/PlanningPrenotazioni.js';
import LogsPage from './pages/LogsPage.js';
import SystemSettingsPage from './pages/SystemSettingsPage.js';
import StoricoOrdiniCliente from './pages/StoricoOrdiniCliente';
import FixedPriceMenusPage from './pages/FixedPriceMenusPage';
import CongressTodayMonitorPage from './pages/CongressTodayMonitorPage';
import DocumentiEmessiPage from './pages/DocumentiEmessiPage';
import PortalSso from './pages/PortalSso';
import SpaDashboardPage from './pages/SpaDashboardPage';
import SpaOperationsPage from './pages/SpaOperationsPage';
import SpaClientsPage from './pages/SpaClientsPage';
import SpaClientProfilePage from './pages/SpaClientProfilePage';
import SpaClinicalRecordPage from './pages/SpaClinicalRecordPage';
import SpaReportsPage from './pages/SpaReportsPage';
import SpaPlannerPage from './pages/SpaPlannerPage';
import SpaCatalogPage from './pages/SpaCatalogPage';
import SpaFinancePage from './pages/SpaFinancePage';
import SpaWaitlistPage from './pages/SpaWaitlistPage';
import SpaCommunicationsPage from './pages/SpaCommunicationsPage';
import SpaExternalEngagementPage from './pages/SpaExternalEngagementPage';
import { usePermissions } from './contexts/PermissionsContext';
import { spaHomeRoute } from './utils/routePermissions';

export function SpaHomeRoute() {
  const { canVisit } = usePermissions();
  return <Navigate to={spaHomeRoute(canVisit) || '/spa/dashboard'} replace />;
}

function ProtectedLayout({ isAuthenticated }) {
  return (
    <ProtectedRoute isAuthenticated={isAuthenticated}>
      <Outlet />
    </ProtectedRoute>
  );
}

function HomeRoute() {
  const tenantType = String(localStorage.getItem('tenantType') || '').toUpperCase();
  if (tenantType === 'SPA') {
    return <SpaHomeRoute />;
  }
  if (tenantType === 'SALE_CONGRESSI') {
    return <Navigate to="/prenotazione" replace />;
  }
  return <Home />;
}

function SpaTenantRoute({ children }) {
  const tenantType = String(localStorage.getItem('tenantType') || '').toUpperCase();
  if (tenantType !== 'SPA') {
    return <Navigate to="/home" replace />;
  }
  return children;
}

function AppRoutes({ isAuthenticated }) {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/login" element={<Login />} />
      <Route path="/reset-password" element={<Login />} />
      <Route path="/sso" element={<PortalSso />} />
      <Route path="/spa/external-engagement" element={<SpaExternalEngagementPage />} />

      <Route element={<ProtectedLayout isAuthenticated={isAuthenticated} />}>
        <Route path="/spa" element={<SpaTenantRoute><SpaHomeRoute /></SpaTenantRoute>} />
        <Route path="/home" element={<HomeRoute />} />
        <Route path="/landing_page" element={<LandingPage />} />
        <Route path="/lista_prodotti" element={<ListaProdotti />} />
        <Route path="/mappa_tavoli" element={<MappaTavoli />} />
        <Route path="/comande" element={<SelezioneComande />} />
        <Route path="/prenotazione" element={<Prenotazioni />} />
        <Route path="/lista_prenotazioni" element={<ListaPrenotazioni />} />
        <Route path="/stampa_prenotazioni" element={<StampaPrenotazioni />} />
        <Route path="/lista_comande" element={<ListaOrdini />} />
        <Route path="/clienti" element={<ClientiPage />} />
        <Route path="/statistiche" element={<Statistiche />} />
        <Route path="/utenti" element={<Utenti />} />
        <Route path="/menu" element={<ConfigurazioneMenu />} />
        <Route path="/categorie" element={<GestioneCategorie />} />
        <Route path="/varianti" element={<GestioneVarianti />} />
        <Route path="/admin_page" element={<AdminPage />} />
        <Route path="/punto_cassa" element={<PuntoCassa />} />
        <Route path="/comunicazioni" element={<Comunicazioni />} />
        <Route path="/fatturazione" element={<FatturazionePage />} />
        <Route path="/documenti-emessi" element={<DocumentiEmessiPage />} />
        <Route path="/allestimenti-sale" element={<GestioneAllestimentiPage />} />
        <Route path="/allestimenti-congressi" element={<GestioneSetupsPage />} />
        <Route path="/tipi-utilizzo" element={<GestioneUsageTypesPage />} />
        <Route path="/reparti" element={<GestioneRepartiPage />} />
        <Route path="/preventivi" element={<Preventivi />} />
        <Route path="/planning" element={<PlanningPrenotazioni />} />
        <Route path="/logs" element={<LogsPage />} />
        <Route path="/impostazioni-sistema" element={<SystemSettingsPage />} />
        <Route path="/settings" element={<SystemSettingsPage />} />
        <Route path="/storico-ordini-cliente" element={<StoricoOrdiniCliente />} />
        <Route path="/menu-prezzo-fisso" element={<FixedPriceMenusPage />} />
        <Route path="/monitor-eventi" element={<CongressTodayMonitorPage />} />
        <Route path="/spa/dashboard" element={<SpaTenantRoute><SpaDashboardPage /></SpaTenantRoute>} />
        <Route path="/spa/operations" element={<SpaTenantRoute><SpaOperationsPage /></SpaTenantRoute>} />
        <Route path="/spa/clients" element={<SpaTenantRoute><SpaClientsPage /></SpaTenantRoute>} />
        <Route path="/spa/waitlist" element={<SpaTenantRoute><SpaWaitlistPage /></SpaTenantRoute>} />
        <Route path="/spa/communications" element={<SpaTenantRoute><SpaCommunicationsPage /></SpaTenantRoute>} />
        <Route path="/spa/clients/:id" element={<SpaTenantRoute><SpaClientProfilePage /></SpaTenantRoute>} />
        <Route path="/spa/clients/:id/clinical" element={<SpaTenantRoute><SpaClinicalRecordPage /></SpaTenantRoute>} />
        <Route path="/spa/reports" element={<SpaTenantRoute><SpaReportsPage /></SpaTenantRoute>} />
        <Route path="/spa/planner" element={<SpaTenantRoute><SpaPlannerPage /></SpaTenantRoute>} />
        <Route path="/spa/catalog" element={<SpaTenantRoute><SpaCatalogPage /></SpaTenantRoute>} />
        <Route path="/spa/finance" element={<SpaTenantRoute><SpaFinancePage /></SpaTenantRoute>} />
      </Route>
    </Routes>
  );
}

export default AppRoutes;
